import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
export function ContentsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const contents = [{
    number: '01',
    title: 'Diagnóstico de tu Rutina',
    description: 'Identifica por dónde se fuga tu energía antes de que abras la laptop.'
  }, {
    number: '02',
    title: 'El Menú de Tareas Rápidas',
    description: '¿Tienes 7 minutos de paz inesperada? Sabrás exactamente qué tarea de tu negocio hacer para avanzar, en lugar de perderte en Instagram.'
  }, {
    number: '03',
    title: 'Señal Visual: El Sistema de "Semáforo"',
    description: 'Para que tus hijos sepan cuándo pueden entrar a tu oficina/espacio y cuándo deben esperar.'
  }, {
    number: '04',
    title: 'Rituales de Corte',
    description: 'Cómo cerrar el modo "Negocio" y pasar al modo "Mamá" en 3 minutos sin llevarte el estrés a la cena.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section ref={ref} className="w-full bg-white py-20 md:py-28" data-id="element-20">
      <div className="max-w-6xl mx-auto px-6" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-22">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D]" data-id="element-23">
            Lo que encontrarás dentro
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-24">
          {/* Content List */}
          <motion.div variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="space-y-6" data-id="element-25">
            {contents.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex gap-6" data-id="element-26">
                <div className="flex-shrink-0 w-14 h-14 bg-[#B794C0] rounded-full flex items-center justify-center" data-id="element-27">
                  <span className="font-['Playfair_Display'] text-white font-bold text-lg" data-id="element-28">
                    {item.number}
                  </span>
                </div>

                <div data-id="element-29">
                  <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#2D2D2D] mb-2" data-id="element-30">
                    {item.title}
                  </h3>
                  <p className="text-[#4A4A4A] leading-relaxed" data-id="element-31">
                    {item.description}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>

          {/* Traffic Light Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.7,
          delay: 0.3,
          ease: 'easeOut'
        }} className="flex justify-center" data-id="element-32">
            <img src="https://cdn.magicpatterns.com/uploads/1txtwEixkDCxdJXUAbpofe/Imagen_para_pagina_de_ventas_2.png" alt="Sistema de semáforo para trabajar con hijos" className="w-full max-w-lg rounded-2xl shadow-xl" data-id="element-33" />
          </motion.div>
        </div>
      </div>
    </section>;
}